import { defineNuxtPlugin, useRuntimeConfig } from '#imports'

import { useI18nLocale } from '@backmarket/nuxt-module-i18n/useI18nLocale'
import { createIdentificationUniqueId } from '@backmarket/nuxt-module-identification/createIdentificationUniqueId'
import { useVisitorId } from '@backmarket/nuxt-module-identification/useVisitorId'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'
import { toRfc4646Locale } from '@backmarket/utils/string/toRfc4646Locale'

import { useHttpStore } from './composables/useHttpStore'
import { createHttpStream } from './composables/useHttpStream'
import { HEADERS } from './constants'

export default defineNuxtPlugin({
  name: 'http-v2-stream-client',
  dependsOn: ['http-v2-client'],
  setup() {
    const config = useRuntimeConfig().public.http2
    const { market } = useMarketplace()
    const locale = useI18nLocale()

    window.$httpStream = createHttpStream({
      getDefaultBaseUrl() {
        return config.baseUrlClient.replaceAll('{market.domain}', market.domain)
      },

      getDefaultHeaders() {
        const httpStore = useHttpStore()
        const visitorId = useVisitorId()

        const headers = {
          [HEADERS.ACCEPT_LANGUAGE]: toRfc4646Locale(locale),
          [HEADERS.CSRF_TOKEN]: httpStore.value.csrf ?? '',
          [HEADERS.ENCODING]: 'identity',
          [HEADERS.IDENTIFICATION_REQUEST_ID]: createIdentificationUniqueId(),
          [HEADERS.IDENTIFICATION_VISITOR_ID]: visitorId,
          [HEADERS.DEPRECATED_MARKET_COUNTRY_CODE]: market.countryCode,
          [HEADERS.MARKET_MARKETPLACE]: market.marketplace,
          [HEADERS.APP_PLATFORM]: 'web',
        }

        return headers
      },
    })
  },
})
